export default "__VITE_ASSET__skEMpcJg__"